import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ATLANTA_CREDITS, DMV_CREDITS, NATIONAL_CREDITS } from './credits';

@Component({
  selector: 'app-credits-content',
  imports: [],
  templateUrl: './credits-content.component.html',
  styleUrl: './credits-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditsContentComponent {
  readonly NATIONAL_CREDITS = NATIONAL_CREDITS;
  readonly ATLANTA_CREDITS = ATLANTA_CREDITS;
  readonly DMV_CREDITS = DMV_CREDITS;
}
